/* eslint-disable react/no-danger */
import React, { useEffect } from 'react';
import { useDispatch } from 'react-redux';
import { useT } from 'talkr';
import s from './index.module.scss';
import bg1 from './img/short_1.jpg';
import ActionBar from '../../components/actionBar';

function WelcomeEverydoggy() {
  const { T } = useT();
  const dispatch = useDispatch();

  useEffect(() => {
    dispatch({
      type: 'IS_STATUSBAR_TRANSPARENT',
      payload: true,
    });
  });

  return (
    <div className={s.welcomeEverydoggy}>
      <div className={s.welcomeEverydoggy_text}>
        <div
          className={s.welcomeEverydoggy_title}
          dangerouslySetInnerHTML={{ __html: T('welcomeEverydoggy_title') }}
        />
        <div className={s.welcomeEverydoggy_description}>{T('welcomeEverydoggy_description')}</div>
      </div>
      <img className={s.welcomeEverydoggy_bg} src={bg1} alt={s.welcome} />
      <div className={s.welcomeEverydoggy_shadow} />
      <ActionBar currentStepCompleted show transparentBg />
    </div>
  );
}

export default WelcomeEverydoggy;
